(function () {
  if (window.__personalizationFeeSyncLoaded) return;
  window.__personalizationFeeSyncLoaded = true;

  var isSyncing = false;
  var syncRequestedWhileSyncing = false;
  var latestCartSnapshot = null;
  var pendingCartSnapshot = null;
  var isEmittingFromSync = false;
  var isApplyingFeeSyncUpdate = false;
  var runningSyncPromise = null;
  var allowNativeCheckoutSubmit = false;
  var isCheckoutSyncing = false;
  var latestCartSnapshotAtMs = 0;
  window.__personalizationFeeSyncMutationInFlight = false;
  var debugCounter = 0;
  var scheduledServerSyncTimer = null;

  function debugLog(hypothesisId, location, message, data) {
    try {
      var payload = {
        hypothesisId: hypothesisId,
        location: location,
        message: message,
        data: isObject(data) ? data : {},
        timestamp: Date.now(),
      };
      if (typeof globalThis !== "undefined" && globalThis.process && globalThis.process.versions && globalThis.process.versions.node) {
        var fs = null;
        try {
          fs = globalThis.require && globalThis.require("fs");
          if (!fs) fs = (0, eval)("require")("fs");
        } catch (_err) {}
        if (fs && typeof fs.appendFileSync === "function") {
          fs.appendFileSync("/opt/cursor/logs/debug.log", JSON.stringify(payload) + "\n");
        }
      }
      if (typeof window !== "undefined") {
        if (!Array.isArray(window.__pfsDebugLogs)) window.__pfsDebugLogs = [];
        window.__pfsDebugLogs.push(payload);
        debugCounter += 1;
        if (debugCounter <= 80 && typeof console !== "undefined" && console.info) {
          console.info("[pfs-debug]", payload);
        }
      }
    } catch (_error) {}
  }

  function isObject(value) {
    return value && typeof value === "object" && !Array.isArray(value);
  }

  function getLineProperties(line) {
    return isObject(line && line.properties) ? line.properties : {};
  }

  function hasPersonalizationData(line) {
    var properties = getLineProperties(line);
    var keys = Object.keys(properties);
    if (!keys.length) return false;

    return keys.some(function (key) {
      var normalized = String(key || "").toLowerCase();
      return (
        normalized.indexOf("personalized text") !== -1 ||
        normalized.indexOf("_playerid") !== -1 ||
        normalized.indexOf("_original") !== -1 ||
        normalized.indexOf("_font") !== -1 ||
        normalized.indexOf("_direction") !== -1
      );
    });
  }

  function isPersonalizationFeeLine(line) {
    var handle = String((line && line.handle) || "").toLowerCase();
    var title = String((line && line.product_title) || "").toLowerCase();
    var productType = String((line && line.product_type) || "").toLowerCase();
    var sku = String((line && line.sku) || "").toLowerCase();

    return (
      handle === "personalization-add-on" ||
      title === "personalization fee" ||
      productType === "personalization fee" ||
      sku === "engrave"
    );
  }

  function getPersonalizedQuantity(cart) {
    return (cart.items || []).reduce(function (total, line) {
      if (isPersonalizationFeeLine(line)) return total;
      if (!hasPersonalizationData(line)) return total;
      return total + (Number(line.quantity) || 0);
    }, 0);
  }

  function getFeeLines(cart) {
    return (cart.items || []).filter(isPersonalizationFeeLine);
  }

  async function fetchCart() {
    var response = await fetch(
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/") + "cart.js",
      { credentials: "same-origin" }
    );
    if (!response.ok) return null;
    return response.json();
  }

  function hasCartShape(cart) {
    return !!(cart && Array.isArray(cart.items));
  }

  function createFeeSignature(cart) {
    if (!hasCartShape(cart)) return "";
    return (cart.items || [])
      .filter(isPersonalizationFeeLine)
      .map(function (line) {
        return String(line.key || "") + ":" + String(Number(line.quantity) || 0);
      })
      .sort()
      .join("|");
  }

  function cacheCartSnapshot(cart) {
    if (!hasCartShape(cart)) return;
    latestCartSnapshot = cart;
    latestCartSnapshotAtMs = Date.now();
    window.__LATEST_CART_SNAPSHOT__ = cart;
  }

  function shouldApplyFeeSync(cart) {
    if (!hasCartShape(cart)) return false;
    var feeLines = getFeeLines(cart);
    if (!feeLines.length) return false;
    var desiredFeeQty = getPersonalizedQuantity(cart);
    var currentFeeQty = feeLines.reduce(function (sum, line) {
      return sum + (Number(line.quantity) || 0);
    }, 0);
    return currentFeeQty !== desiredFeeQty || feeLines.length > 1;
  }

  function getSyncMetrics(cart) {
    if (!hasCartShape(cart)) {
      return {
        hasCartShape: false,
        personalizedQty: 0,
        feeQty: 0,
        feeLines: 0,
      };
    }
    var feeLines = getFeeLines(cart);
    var personalizedQty = getPersonalizedQuantity(cart);
    var feeQty = feeLines.reduce(function (sum, line) {
      return sum + (Number(line.quantity) || 0);
    }, 0);
    return {
      hasCartShape: true,
      items: cart.items.length,
      personalizedQty: personalizedQty,
      feeQty: feeQty,
      feeLines: feeLines.length,
      feeKeys: feeLines.map(function (line) { return String(line.key || ""); }),
      shouldApply: feeQty !== personalizedQty || feeLines.length > 1,
    };
  }

  function isLikelyStaleCartSnapshot(metrics) {
    return !!(
      metrics &&
      metrics.hasCartShape &&
      metrics.feeLines > 0 &&
      metrics.feeQty > 0 &&
      metrics.personalizedQty === 0
    );
  }

  function getEventCartSnapshot(event) {
    if (!event) return null;
    var detail = event.detail;
    if (hasCartShape(detail)) return detail;
    if (detail && hasCartShape(detail.cart)) return detail.cart;
    return null;
  }

  async function parseCartResponse(response) {
    if (!response || !response.ok || typeof response.json !== "function") return null;
    var contentType =
      (response.headers && response.headers.get && response.headers.get("content-type")) || "";
    if (
      contentType &&
      contentType.indexOf("application/json") === -1 &&
      contentType.indexOf("text/javascript") === -1
    ) {
      return null;
    }
    try {
      var payload = await response.json();
      // #region agent log
      debugLog("B", "personalization-fee-sync.js:parseCartResponse", "Parsed mutation response", {
        ok: !!(response && response.ok),
        hasItems: !!(payload && payload.items),
        hasCartItems: !!(payload && payload.cart && payload.cart.items),
      });
      // #endregion
      if (hasCartShape(payload)) return payload;
      if (payload && hasCartShape(payload.cart)) return payload.cart;
    } catch (_error) {
      return null;
    }
    return null;
  }

  function emitCartEvents(cart) {
    var appProvider = document.querySelector("app-provider");
    if (!appProvider || !cart) return;

    function getRegisteredCartSectionIds() {
      return Array.prototype.slice
        .call(document.querySelectorAll("[register-for-cart-updates][section-id]"))
        .map(function (node) {
          return node && node.getAttribute ? node.getAttribute("section-id") : "";
        })
        .filter(Boolean)
        .slice(0, 5)
        .join(",");
    }

    isEmittingFromSync = true;
    try {
      appProvider.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: cart,
          bubbles: true,
          composed: true,
        })
      );
      var sectionIds = getRegisteredCartSectionIds();
      if (sectionIds) {
        fetch(window.location.pathname + "?sections=" + encodeURIComponent(sectionIds), {
          credentials: "same-origin",
        })
          .then(function (response) {
            return response && response.ok ? response.json() : null;
          })
          .then(function (sectionsPayload) {
            if (!isObject(sectionsPayload)) return;
            appProvider.dispatchEvent(
              new CustomEvent("cart:updated-sections", {
                detail: sectionsPayload,
                bubbles: true,
                composed: true,
              })
            );
          })
          .catch(function () {});
      }
    } finally {
      isEmittingFromSync = false;
    }
  }

  async function syncFeeQuantity(preferredCart) {
    if (isSyncing) {
      syncRequestedWhileSyncing = true;
      if (hasCartShape(preferredCart)) pendingCartSnapshot = preferredCart;
      return;
    }
    isSyncing = true;
    syncRequestedWhileSyncing = false;
    if (hasCartShape(preferredCart)) {
      cacheCartSnapshot(preferredCart);
      pendingCartSnapshot = null;
    }

    try {
      var cart = hasCartShape(preferredCart) ? preferredCart : latestCartSnapshot;
      if (!hasCartShape(cart)) {
        cart = await fetchCart();
      }
      if (!hasCartShape(cart)) return;
      cacheCartSnapshot(cart);

      // #region agent log
      debugLog("A", "personalization-fee-sync.js:syncFeeQuantity", "Sync cycle started", {
        fromPreferredCart: hasCartShape(preferredCart),
        ...getSyncMetrics(cart),
      });
      // #endregion

      var metricsBeforeApply = getSyncMetrics(cart);
      if (!shouldApplyFeeSync(cart)) {
        if (isLikelyStaleCartSnapshot(metricsBeforeApply)) {
          var refreshedCart = await fetchCart();
          if (hasCartShape(refreshedCart)) {
            cart = refreshedCart;
            cacheCartSnapshot(cart);
            metricsBeforeApply = getSyncMetrics(cart);
          }
        }
      }

      if (!shouldApplyFeeSync(cart)) {
        // #region agent log
        debugLog("C", "personalization-fee-sync.js:syncFeeQuantity", "Early return: no sync needed", getSyncMetrics(cart));
        // #endregion
        return;
      }
      var feeLines = getFeeLines(cart);
      var desiredFeeQty = getPersonalizedQuantity(cart);
      var feeSignatureBefore = createFeeSignature(cart);

      var root =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      var updates = {};
      for (var i = 0; i < feeLines.length; i += 1) {
        updates[feeLines[i].key] = i === 0 ? desiredFeeQty : 0;
      }

      // #region agent log
      debugLog("D", "personalization-fee-sync.js:syncFeeQuantity", "Dispatching /cart/update.js", {
        desiredFeeQty: desiredFeeQty,
        feeSignatureBefore: feeSignatureBefore,
        updates: updates,
      });
      // #endregion

      isApplyingFeeSyncUpdate = true;
      var updateResponse = null;
      try {
        window.__personalizationFeeSyncMutationInFlight = true;
        updateResponse = await fetch(root + "cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            updates: updates,
          }),
        });
      } finally {
        isApplyingFeeSyncUpdate = false;
        window.__personalizationFeeSyncMutationInFlight = false;
      }
      if (!updateResponse || !updateResponse.ok) return;

      var updateResponseClone =
        typeof updateResponse.clone === "function" ? updateResponse.clone() : null;
      var updatedCart = await parseCartResponse(updateResponseClone || updateResponse);
      if (!hasCartShape(updatedCart)) {
        updatedCart = await fetchCart();
      }
      if (!hasCartShape(updatedCart)) return;

      var updatedFeeQty = getFeeLines(updatedCart).reduce(function (sum, line) {
        return sum + (Number(line.quantity) || 0);
      }, 0);
      var feeSignatureAfter = createFeeSignature(updatedCart);

      // #region agent log
      debugLog("D", "personalization-fee-sync.js:syncFeeQuantity", "Post /cart/update.js snapshot", {
        updatedFeeQty: updatedFeeQty,
        desiredFeeQty: desiredFeeQty,
        feeSignatureBefore: feeSignatureBefore,
        feeSignatureAfter: feeSignatureAfter,
        ...getSyncMetrics(updatedCart),
      });
      // #endregion

      cacheCartSnapshot(updatedCart || cart);

      if (updatedFeeQty !== desiredFeeQty || feeSignatureAfter === feeSignatureBefore) {
        var correctionFeeLines = getFeeLines(updatedCart);
        if (!correctionFeeLines.length) correctionFeeLines = feeLines;
        for (var j = 0; j < correctionFeeLines.length; j += 1) {
          var targetQty = j === 0 ? desiredFeeQty : 0;
          if ((Number(correctionFeeLines[j].quantity) || 0) === targetQty) continue;
          // #region agent log
          debugLog("E", "personalization-fee-sync.js:syncFeeQuantity", "Dispatching fallback /cart/change.js", {
            lineKey: correctionFeeLines[j].key,
            fromQty: Number(correctionFeeLines[j].quantity) || 0,
            toQty: targetQty,
          });
          // #endregion
          isApplyingFeeSyncUpdate = true;
          try {
            window.__personalizationFeeSyncMutationInFlight = true;
            await fetch(root + "cart/change.js", {
              method: "POST",
              credentials: "same-origin",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
              },
              body: JSON.stringify({
                id: correctionFeeLines[j].key,
                quantity: targetQty,
              }),
            });
          } finally {
            isApplyingFeeSyncUpdate = false;
            window.__personalizationFeeSyncMutationInFlight = false;
          }
        }
        updatedCart = await fetchCart();
        if (!hasCartShape(updatedCart)) return;
        cacheCartSnapshot(updatedCart);
      }

      if (!shouldApplyFeeSync(updatedCart)) {
        await emitCartEvents(updatedCart);
      }
    } catch (_error) {
      // no-op: fee sync must not break cart UX.
    } finally {
      isSyncing = false;
      if (syncRequestedWhileSyncing) {
        syncRequestedWhileSyncing = false;
        await runSyncNow(pendingCartSnapshot || latestCartSnapshot);
      }
    }
  }

  function runSyncNow(cartSnapshot) {
    if (hasCartShape(cartSnapshot)) {
      pendingCartSnapshot = cartSnapshot;
      cacheCartSnapshot(cartSnapshot);
    }
    var nextCart = pendingCartSnapshot || latestCartSnapshot;
    pendingCartSnapshot = null;
    if (!runningSyncPromise) {
      runningSyncPromise = Promise.resolve(syncFeeQuantity(nextCart)).finally(function () {
        runningSyncPromise = null;
      });
    }
    return runningSyncPromise;
  }

  async function ensureFeeSyncedBeforeCheckout() {
    if (runningSyncPromise) {
      await runningSyncPromise;
    }
    var now = Date.now();
    var snapshotIsFresh =
      hasCartShape(latestCartSnapshot) && now - latestCartSnapshotAtMs < 1500;
    var cart = snapshotIsFresh ? latestCartSnapshot : null;
    if (!hasCartShape(cart)) {
      cart = await fetchCart();
      if (hasCartShape(cart)) {
        cacheCartSnapshot(cart);
      }
    }
    if (!hasCartShape(cart)) return;
    if (shouldApplyFeeSync(cart)) {
      await runSyncNow(cart);
    }
    if (runningSyncPromise) {
      await runningSyncPromise;
    }
  }

  function shouldSyncBeforeCheckoutSubmit(event) {
    var form = event && event.target;
    if (!(form instanceof HTMLFormElement)) return false;
    var submitter = event && "submitter" in event ? event.submitter : null;
    if (submitter && submitter.getAttribute("name") === "checkout") return true;
    if (submitter && submitter.closest(".cart-express-checkout")) return true;
    var action = form.getAttribute("action") || "";
    return action.indexOf("/checkout") !== -1;
  }

  function isCartMutationRequest(input, init) {
    var requestUrl =
      typeof input === "string" ? input : input && input.url ? input.url : "";
    var method =
      ((init && init.method) || (input && input.method) || "GET").toUpperCase();
    if (method === "GET") return false;

    var pathname = "";
    try {
      pathname = new URL(requestUrl, window.location.origin).pathname;
    } catch (_error) {
      pathname = String(requestUrl || "");
    }

    return /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(pathname);
  }

  function scheduleServerSync(reason) {
    if (scheduledServerSyncTimer) clearTimeout(scheduledServerSyncTimer);
    scheduledServerSyncTimer = setTimeout(function () {
      scheduledServerSyncTimer = null;
      // #region agent log
      debugLog("A", "personalization-fee-sync.js:scheduleServerSync", "Scheduled server sync firing", {
        reason: reason,
      });
      // #endregion
      runSyncNow();
    }, 180);
  }

  function isCartQuantityControlTarget(target) {
    if (!(target instanceof Element)) return false;
    if (
      target.matches(
        'input[name="updates[]"], input[name="updates"], [data-cart-quantity-input], [data-quantity-input]'
      )
    ) {
      return true;
    }
    return !!target.closest(
      '[data-quantity-selector-button], quantity-input button, .quantity-input button, [name="plus"], [name="minus"]'
    );
  }

  function attachQuantityChangeSync() {
    function handleQuantityIntent(event) {
      if (isApplyingFeeSyncUpdate || window.__personalizationFeeSyncMutationInFlight) return;
      var target = event && event.target;
      if (!isCartQuantityControlTarget(target)) return;
      scheduleServerSync("quantity-intent");
    }
    document.addEventListener("change", handleQuantityIntent, true);
    document.addEventListener("click", handleQuantityIntent, true);
  }

  function interceptCartMutations() {
    var originalFetch = window.fetch;
    if (typeof originalFetch !== "function") return;

    window.fetch = function (input, init) {
      var isCartMutation = isCartMutationRequest(input, init);
      var result = originalFetch.apply(window, arguments);
      if (isCartMutation && !isApplyingFeeSyncUpdate) {
        // #region agent log
        debugLog("A", "personalization-fee-sync.js:interceptCartMutations", "Cart mutation intercepted", {
          method: ((init && init.method) || (input && input.method) || "GET").toUpperCase(),
          url:
            typeof input === "string" ? input : input && input.url ? input.url : "",
        });
        // #endregion
        Promise.resolve(result)
          .then(function (response) {
            if (!response || typeof response.clone !== "function") {
              runSyncNow();
              scheduleServerSync("mutation-no-clone");
              return;
            }
            return parseCartResponse(response.clone()).then(function (cartSnapshot) {
              runSyncNow(cartSnapshot);
              scheduleServerSync("mutation-response");
            });
          })
          .catch(function () {
            runSyncNow();
            scheduleServerSync("mutation-catch");
          });
      }
      return result;
    };
  }

  interceptCartMutations();
  attachQuantityChangeSync();

  document.addEventListener(
    "cart:updated",
    function (event) {
      var cartSnapshot = getEventCartSnapshot(event);
      if (isEmittingFromSync) {
        cacheCartSnapshot(cartSnapshot);
        return;
      }
      runSyncNow(cartSnapshot);
    },
    true
  );
  window.addEventListener("pageshow", runSyncNow);
  document.addEventListener(
    "submit",
    function (event) {
      if (!shouldSyncBeforeCheckoutSubmit(event)) return;
      if (allowNativeCheckoutSubmit) {
        allowNativeCheckoutSubmit = false;
        return;
      }
      event.preventDefault();
      if (isCheckoutSyncing) return;
      isCheckoutSyncing = true;
      var form = event.target;
      var submitter = event && "submitter" in event ? event.submitter : null;
      ensureFeeSyncedBeforeCheckout()
        .finally(function () {
          isCheckoutSyncing = false;
          allowNativeCheckoutSubmit = true;
          if (typeof form.requestSubmit === "function") {
            form.requestSubmit(submitter || undefined);
          } else {
            form.submit();
          }
        });
    },
    true
  );

  runSyncNow();
})();
